import { useShallow } from 'zustand/react/shallow'
import { useState } from 'react'
import PhoneInput from 'components/UI/PhoneInput'
import Sidebar from 'components/Sidebar'
import CountrySelector from 'components/CountrySelector'
import Input from 'components/UI/Input'
import Select from 'components/UI/Select'
import { optionsParser, t } from 'helpers'
import { notif } from 'helpers/notif'
import { useAppStore } from 'store'
import { DROPDOWN_OPTIONS } from 'types/enums'

const properties = [
	'name',
	'email',
	'mobilephone',
	'location',
	'city',
	'gender',
]

const AddContactSidebar = (): JSX.Element => {
	const [openSidebar, onAdd, additional, type, setOpenSidebar] = useAppStore(
		useShallow((state) => [
			state.addContactSidebar?.open,
			state.addContactSidebar?.onAdd,
			state.addContactSidebar?.additional,
			state.addContactSidebar?.type,
			state.setAddContactSidebar,
		]),
	)
	const [values, setValues] = useState<{ [key: string]: string }>(
		properties?.reduce(
			(prev, next) => ({
				...prev,
				[next]: '',
			}),
			{},
		),
	)

	const addFriend = type === 'actor-friends'

	const onClose = (): void => setOpenSidebar(false, () => null)

	const addUser = (): void => {
		if (values?.name && values?.email && onAdd) {
			if (addFriend) onAdd(values)
			else onAdd({ ...values, phone: values?.mobilephone })
		} else notif('info', t('APP_FILL_ALL_FIELDS'))
	}

	const fields = addFriend ? properties.slice(0, 2) : properties

	return (
		<Sidebar
			open={!!openSidebar}
			onClose={onClose}
			header={{
				title: 'APP_NETWORK_ADD_USER_SIDEBAR_TITLE',
				description: 'APP_NETWORK_ADD_USER_SIDEBAR_DESCRIPTION',
			}}
			additional={additional}
			buttons={[
				{
					onClick: addUser,
					children: t('APP_ADD_USER_BUTTON'),
				},
			]}>
			<>
				{fields?.map((name) =>
					name === 'location' ? (
						<CountrySelector
							key={name}
							value={values[name]}
							onChange={(e) =>
								setValues((prev) => ({ ...prev, [name]: e.target.value }))
							}
						/>
					) : name === 'mobilephone' ? (
						<PhoneInput
							key={name}
							label={`APP_${name?.toUpperCase()}_LABEL`}
							defaultValue={values[name]}
							onChange={(e) =>
								setValues((prev) => ({ ...prev, [name]: e.target.value }))
							}
						/>
					) : name === 'gender' ? (
						<Select
							key={name}
							onChange={(e) =>
								setValues((prev) => ({ ...prev, [name]: e.target.value }))
							}
							name={name}
							label={`APP_${name?.toUpperCase()}_LABEL`}
							inputProps={{
								value: values[name],
							}}
							options={optionsParser(DROPDOWN_OPTIONS.GENDERS)}
						/>
					) : (
						<Input
							key={name}
							label={`APP_${name?.toUpperCase()}_LABEL`}
							value={values[name]}
							onChange={(e) =>
								setValues((prev) => ({ ...prev, [name]: e.target.value }))
							}
						/>
					),
				)}
			</>
		</Sidebar>
	)
}

export default AddContactSidebar
